'use client'

import { createContext } from 'react'

import { VasEntryPointModel } from '@marketplace-web/vas/vas-data'

export type VasEntryPointsContextType = {
  vasEntryPoints?: Array<VasEntryPointModel>
}

export const initialValues: VasEntryPointsContextType = {
  vasEntryPoints: undefined,
}

const VasEntryPointsContext = createContext<VasEntryPointsContextType>(initialValues)

export default VasEntryPointsContext
